export default "__VITE_ASSET__CwJ5gTXk__"